import { ConfigElement } from 'components-fabric/_types';
import { applySpec, clone, propOr } from 'ramda';
import { ScreenTemplate } from '@components-fabric/types';
import { getLabel } from '../utils/get-label';
import { getRoutePath } from '../utils/get-path';
import { getProtected, getRoles } from '../utils/get-protected';
import { getRouteId } from '../utils/get-id';

export const routeSpec = (cfg: ConfigElement, context?: any) => {
  const result = applySpec<ScreenTemplate>({
    id: getRouteId,
    label: getLabel,
    to: getRoutePath,
    roles: getRoles,
    protected: getProtected,
    entityId: propOr('NOT_SET', 'entityId'),
    component: propOr('NOT_SET', 'component'),
  })(cfg);
  console.log('routeSpec:', cfg, context, result, mapRoute(cfg, context));
  return result;
};

const defComponent = {
  id: 'NOT_SET',
  label: 'NOT_SET',
  to: 'NOT_SET',
  roles: [],
  protected: false,
  entityId: 'NOT_SET',
};

export const mapRoute = (obj: ConfigElement, context: any) => {
  const result = {
    ...defComponent,
    id: getRouteId(obj, context),
    label: getLabel(obj),
    to: getRoutePath(obj),
    roles: getRoles(obj),
    protected: getProtected(obj),
    entityId: propOr('NOT_SET', 'entityId', obj),
    component: propOr('NOT_SET', 'component', obj),
  };
  context.route = result;

  return result;
};
